import React from 'react'

const CropIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 21 18" fill="none">
        <path d="M4.86761 1V14H19.2003" stroke="black" />
        <path d="M15.533 17L15.533 4L1.20032 4" stroke="black" />
    </svg>
)

export default CropIcon
